module.exports = __webpack_public_path__ + "img/img_safety_phone_img5.9a35517c.png";